import { ActionCardData, ActionCardModel, SectionData } from '@playbooks/action-cards-utils/src'

function getRequitedNotFilledFieldIds(sections: SectionData[]) {
  return (
    new ActionCardModel({ sections } as ActionCardData)
      .getSearchService()
      .filterRequired()
      .filterVisible()
      .filterEmptyInputNodes()
      .map(field => (field.data as { id: string }).id) || []
  )
}

export default getRequitedNotFilledFieldIds
